<template>
    <div class="p-1">
        <div-table :config="configList" :data="sourcings" :idWharhouse="idWharhouse" :currentUser="currentUser"
            :sellers="sellers" :element="element" :statusShipp="statusExpedition" :ProcessingInfo="ProcessingInfo"
            @reset="reset" @refresh="refresh" @showProducts="showProducts" @filtrer="filtrer" @search="search"
            :loading="loading" :paginate="paginate" @paginatation="paginatation" @emtyTabId="emtyTabId"
            @selectAllCheckbox="selectAllCheckbox" @getRowDetail="getRowDetail" :tabId="tabId"></div-table>
    </div>
</template>

<script>
import config from "./config";
export default {
    props: {
        currentUser: { type: Object },
        idWharhouse: { type: Object },
    },
    data() {
        return {
            configList: config.list,
            loading: false,
            sourcings: [],
            element: {},
            show_modal: false,
            limit: 50,
            filters: {},
            paginate: {
                total: 0,
                currentpage: 1,
                lastpage: 0,
                per_page: 0,
            },
            sellers: [],
            statusExpedition: [
                "pending",
                "en attente de paiement",
                "en attente de validation",
                "valide",
                "rejected"
            ],
            methods: [
                "virement bancaire", 
                "wise", 
                "demande de crédit"
            ],
            messageStatus: [
                'read', 
                'unread', 
                'seller read', 
                'seller unread'
            ],
            country: [
                { name: "China", code: "CN", currencyCode: "XOF" },
                { name: "Morocco", code: "MA", currencyCode: "MAD" },
                { name: "United Arab Emirates", code: "AE", currencyCode: "XOF" },
                { name: "Turkey", code: "TR", currencyCode: "XOF" },
            ],
            ProcessingInfo: { count: 0, total: 0 },
            warehouses: [],
            tabId: [],
        };
    },
    computed: {
        warhouseSelected() {
            return this.$store.getters["wharhouse/warhouseSelected"]({
                user: _.pick(this.currentUser, ["countries"]),
            });
        },
    },
    watch: {
        warhouseSelected: async function (oldVal, newVal) { },
        idWharhouse: async function (oldVal, newVal) {
            this.idWharhouse = oldVal;
            await this.reset();
        }
    },
    async mounted() {
        //
        this.currentUser.type2 = this.currentUser.type === "Seller" ? this.currentUser.type : "COD";

        //
        if (this.currentUser.type === "Seller") {
            this.messageStatus = ['read', 'unread', 'ceo read', 'ceo unread']

            let pos = this.configList.columns.map(function (e) { return e.name; }).indexOf("Seller");
            if (pos != -1) this.configList.columns.splice(pos, 1);

            let posC = this.configList.columns.map(function (e) { return e.name; }).indexOf("Charges");
            if (posC != -1) this.configList.columns.splice(posC, 1);

            let pos_1 = this.configList.columns.map(function (e) { return e.type; }).indexOf("checkbox");
            if (pos_1 != -1) this.configList.columns.splice(pos_1, 1);

            let pos1 = this.configList.filters.elements.champs.map(function (e) { return e.key; }).indexOf("status_printing");
            if (pos1 != -1) this.configList.filters.elements.champs.splice(pos1, 1);
        }

        if (this.currentUser.type === "SourcingAtlas" || this.currentUser.type === "sourcing") {
            const { champs } = this.configList.filters.elements;
            const pos = champs.findIndex(e => e.key === "country");
            if (pos !== -1) champs.splice(pos, 1);
        }

        //
        if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
        else this.$f.objectToQueryString({ limit: this.limit });

        //
        if (this.filters.name) await this.search(this.filters.name);
        else await this.getSourcings(this.filters);

        //
        if (this.currentUser.type !== "Seller") {
            await this.getSellers();
            this.setDataSelect("seller", this.sellers, null);
        }

        //
        if (this.currentUser.type !== "SourcingAtlas" && this.currentUser.type !== "sourcing") {
            this.setDataSelect("country", this.country, null);
        }

        //
        this.setDataSelect("status", this.statusExpedition, null);
        this.setDataSelect("paymentMethod", this.methods, null);
        this.setDataSelect("messageStatus", this.messageStatus, null);
        this.setDataSelect("status_printing", ["Pending", "Déjà Imprimés"], null);

        //
        await this.getCurrentWarehouses();
        this.setDataSelect("warehouse", this.warehouses, null);
    },
    methods: {
        selectAllCheckbox($event) {
            let columns = document.querySelectorAll(".rowCheckbox");
            this.tabId = [];
            if ($event.target.checked == true) {
                columns.forEach((column) => {
                    column.checked = true;
                    this.tabId.push({
                        id: column.id,
                        idData: column.idData,
                        status: column.getAttribute("status"),
                        tickets: JSON.parse(column.getAttribute("tickets")),
                        details: JSON.parse(column.getAttribute("details")),
                    });
                });
            } else {
                columns.forEach((column) => {
                    column.checked = false;
                });
                this.tabId = [];
            }
        },
        getRowDetail(item, id) {
            let itemInRow = this.tabId.filter((item) => item.id === id);
            let isItemInRow = itemInRow.length > 0;

            if (isItemInRow) {
                let pos = this.tabId
                    .map(function (e) {
                        return e.id;
                    })
                    .indexOf(id);
                this.tabId.splice(pos, 1);
            } else {
                this.tabId.push({
                    id: id,
                    idData: item.id,
                    status: item.status,
                    details: item.details,
                    tickets: item.details.map((el) => el.ticket || "").filter((ti) => ti),
                });
            }

            if (this.tabId.length === 0) {
                let columns = document.querySelectorAll(".checkallbbox");
                columns.forEach((column) => {
                    column.checked = false;
                });
            }
        },
        emtyTabId() {
            let columns = document.querySelectorAll(".rowCheckbox");
            columns.forEach((column) => {
                column.checked = false;
            });
            this.tabId = [];
        },
        async getwharhouseId() {
            await this.$store
                .dispatch("wharhouse/getwharhouseId", {
                    country: this.warhouseSelected,
                })
                .then((res) => {
                    this.idWharhouse = res;
                });
        },
        async getCurrentWarehouses() {
            var newArray = [];
            const res = await this.$server.search("warehouses", { limit: 100 });
            if (res && res.content.results) this.warehouses = res.content.results;

            this.currentUser.countries.forEach((arg) => {
                newArray.push(
                    this.warehouses.find((x) => x.country === (arg.code || arg))
                );
            });

            this.warehouses = newArray;
        },
        setDataSelect(model, data, splice) {
            for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
                if (
                    this.configList.filters.elements.champs[i].type === "select" &&
                    this.configList.filters.elements.champs[i].key === model
                ) {
                    if (!splice) {
                        this.configList.filters.elements.champs[i].values = data;
                    } else {
                        this.configList.filters.elements.champs.splice(i, 1);
                    }
                }
            }
        },
        QuantityTotalOrPrices(type, data) {
            var value = 0;
            for (let i in data) {
                if (type == "qte") value += data[i].quantity;
                else
                    value +=
                        parseFloat(data[i][type]) * parseFloat(data[i].quantity || 1);
            }
            return value;
        },
        async getSellers() {
            if (this.currentUser.type !== "Seller") {
                const filter = {
                    type: "Seller",
                    limit: 10,
                };
                if (this.currentUser.type != "Seller") {
                    const res = await this.$server.search("users", filter);
                    if (res.content.results) this.sellers = res.content.results;
                    else this.sellers = [];
                }
            }
        },
        async reset(data) {
            this.emtyTabId();
            let lmitt = this.limit;

            if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();

            if (this.filters["limit"]) lmitt = this.filters["limit"];
            this.filters["page"] = 1;
            
            this.$f.objectToQueryString({ limit: lmitt });
            await this.getSourcings({ limit: lmitt });
        },
        async filtrer(data) {
            this.emtyTabId();
            if (this.$f.QueryStringToobject()) {
                this.filters = this.$f.QueryStringToobject();
            }
            
            delete this.filters.page;
            delete this.filters.name;

            if (!this.filters["limit"]) this.filters["limit"] = this.limit;

            if (data.status) this.filters.status = data.status;
            else delete this.filters.status;

            if (data.status_printing) {
                if (data.status_printing === "Pending") this.filters.isPrinter = false;
                else this.filters.isPrinter = true;
            } else delete this.filters.isPrinter;

            if (data.country) this.filters.country = data.country.code; 
            else delete this.filters.country;
            
            if (data.warehouse) this.filters["warehouses"] = data.warehouse.country;
            else delete this.filters["warehouses"];

            if (data.paymentMethod)
                this.filters["paymentMethod.name"] = data.paymentMethod;
            else delete this.filters["paymentMethod.name"];

            if (data.seller) this.filters["seller._id"] = data.seller._id;
            else delete this.filters["seller._id"];

            if (data.messageStatus) {
                if (this.currentUser.type ==="Seller") {
                    this.filters['type'] = (data.messageStatus === 'read' || data.messageStatus === 'unread') ? 'COD' : 'Seller',
                    this.filters['vue'] = (data.messageStatus === 'read' || data.messageStatus === 'ceo read') ? true : false
                } else {
                    this.filters['type'] = (data.messageStatus === 'read' || data.messageStatus === 'unread') ? 'Seller' : 'COD',
                    this.filters['vue'] = (data.messageStatus === 'read' || data.messageStatus === 'seller read') ? true : false
                }
            } else {
                delete this.filters['type']
                delete this.filters['vue']
            }

            this.paginate.currentpage = 1;
            this.$f.objectToQueryString(this.filters);
            await this.getSourcings(this.filters);
        },
        async search(data) {
            this.emtyTabId();
            this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };

            const limit = this.filters["limit"] || this.limit;
            const search = {
                name: data.trim(),
                limit: parseInt(limit),
                country: this.getUserCountry()
            };

            this.$f.objectToQueryString(search);
            const res = await this.$server.find("sourcings", search);

            if (res.content.results) {
                this.sourcings = res.content.results;
                this.paginate = {
                    total: res.content.total,
                    currentpage: res.content.current_page,
                    lastpage: res.content.last_page,
                    per_page: res.content.per_page
                };

                this.sourcings = this.sourcings.map(element => {
                    return {
                        ...element,
                        quantity: this.QuantityTotalOrPrices("qte", element.details),
                        amount: this.$f.groupAmountByCurrency(element.details, element.fees, "sourcings", "html"),
                        Nb_views: element.messages.filter(x => x.access.type !== this.currentUser.type2 && !x.access.vue).length,
                        chargesPayment: this.getPaymentLinks(element.charges, "charges"),
                        creditsPayment: this.getPaymentLinks(element.credits, "credits")
                    };
                });
            } else {
                this.sourcings = [];
                this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
            }
        },
        getUserCountry() {
            const userCountryMap = { SourcingAtlas: "AE", sourcing: "CN" };
            return userCountryMap[this.currentUser.type] || null;
        },
        getPaymentLinks(items, type) {
            if (!items || items.length === 0) return '';

            return items.map((item, index) => `
                <span class='flex flex-col items-center gap-1'>
                    <a class="text-blue-600" target="_blank" href="/${type}/edit/${item._id}">
                        <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                            <path d="M14 4h-13v18h20v-11h1v12h-22v-20h14v1zm10 5h-1v-6.293l-11.646 11.647-.708-.708 11.647-11.646h-6.293v-1h8v8z"/>
                        </svg>
                    </a>
                    <span class="${item.status === 'applied' ? 'text-green-700 border-green-600' : 'text-yellow-700 border-yellow-600'} text-xs font-medium border rounded-full px-2">${item.status}</span>
                </span>
                ${index !== items.length - 1 ? ' | ' : ''}
            `).join('');
        },
        async getUser() {
            const res = await this.$me;
            this.currentUser = res.content;
        },
        async getSourcings(filters) {
            this.loading = true;
            filters.limit = filters.limit || this.limit;

            const userCountryMap = { SourcingAtlas: "AE", sourcing: "CN" };
            const country = userCountryMap[this.currentUser.type];
            if (country) {
                filters.country = country;
            }

            try {
                const res = await this.$server.search("sourcings", filters);
                this.sourcings = res.content.results || [];
                this.paginate = {
                    total: res.content.total || 0,
                    currentpage: res.content.current_page || 1,
                    lastpage: res.content.last_page || 1,
                    per_page: res.content.per_page || 0
                };

                this.ProcessingInfo = {
                    count: 0,
                    total: 0
                };

                for (const element of this.sourcings) {
                    element.quantity = this.QuantityTotalOrPrices("qte", element.details);
                    element.amountMad = this.QuantityTotalOrPrices("priceDH", element.details) + this.QuantityTotalOrPrices("priceDH", element.fees);
                    element.amount = this.$f.groupAmountByCurrency(element.details, element.fees, "sourcings", "html");
                    element.Nb_views = element.messages.filter(x => x.access.type !== this.currentUser.type2 && !x.access.vue).length;

                    if (element.charges && element.charges.length > 0) {
                        element.chargesPayment = this.getChargesOrCreditsPayment(element.charges, "charges");
                    }

                    if (element.credits && element.credits.length > 0) {
                        element.creditsPayment = this.getChargesOrCreditsPayment(element.credits, "credits");
                    }
                }
            } catch (error) {
                console.error('Error fetching sourcings:', error);
                this.sourcings = [];
                this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
            } finally {
                this.loading = false;
            }
        },
        getChargesOrCreditsPayment(items, type) {
            const paymentItems = items.map((item, index) => {
                return `
                    <span class='flex flex-col items-center gap-1'>
                        <a class="text-blue-600" target="_blank" href="/${type}/edit/${item._id}">
                            <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                                <path d="M14 4h-13v18h20v-11h1v12h-22v-20h14v1zm10 5h-1v-6.293l-11.646 11.647-.708-.708 11.647-11.646h-6.293v-1h8v8z"/>
                            </svg>
                        </a>
                        <span class="${item.status === 'applied' ? 'text-green-700 border-green-600' : 'text-yellow-700 border-yellow-600'} text-xs font-medium border rounded-full px-2">${item.status}</span>
                    </span>
                    ${index !== items.length - 1 ? `<b class="mx-2">|</b>` : ''}
                `;
            });
            return `<span class='inline-flex'>${paymentItems.join('')}</span>`;
        },
        async refresh() {
            this.emtyTabId();
            if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
            this.$f.objectToQueryString(this.filters);

            if (this.filters.name) await this.search(this.filters.name);
            else await this.getSourcings(this.filters);

            if (this.filters["page"] && this.filters["page"] > 1 && this.sourcings.length == 0) {
                this.filters["page"] = --this.filters["page"];
                this.$f.objectToQueryString(this.filters);
                await this.getSourcings(this.filters);
            }
        },
        showProducts(index) {
            if (this.element !== this.sourcings[index]) {
                this.element = this.sourcings[index];
            } else this.element = null;
        },
        async remove(id) {
            this.$confirm("You want to delete this sourcing?").then(async (res) => {
                if (res) {
                    await this.$server.delete("sourcings", { id: id });
                    await this.refresh();
                    alert("sourcing Deleted", "success");
                }
            });
        },
        async paginatation(direction) {
            var page = 0;
            if (direction == "next") page = ++this.paginate.currentpage;
            else page = --this.paginate.currentpage;

            if (this.$f.QueryStringToobject())
                this.filters = this.$f.QueryStringToobject();
            this.filters["page"] = page;
            this.$f.objectToQueryString(this.filters);

            await this.getSourcings(this.filters);
        }
    }
};
</script>